export function calculateRequiredRawMaterial(newWeight, selectedRecipe) {
  const parsedWeight = parseFloat(newWeight);
  const weight = Number.isFinite(parsedWeight) ? parsedWeight : 0;
  const targetProductionMultiplier = parseFloat(
    selectedRecipe?.recipe?.target_production_carpan,
  );

  const multiplier =
    Number.isFinite(targetProductionMultiplier) && targetProductionMultiplier > 0
      ? targetProductionMultiplier
      : (selectedRecipe?.recipeItems ?? []).reduce((total, item) => {
          const isPackaging =
            item?.is_packaging === true ||
            item?.is_packaging === 1 ||
            item?.is_packaging === "1";
          if (isPackaging) {
            return total;
          }

          const recipePerKg = parseFloat(item?.recipe_per_kg);
          return total + (Number.isFinite(recipePerKg) ? recipePerKg : 0);
        }, 0);

  return (weight * multiplier).toFixed(2);
}
